import { ComponentTypes } from "../../config/config";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { FileTypeEnum } from "../enums/fileTypeEnum";

export class StoreItemHelper {
    static removeSaveLocation = (locations: IPageSettings[]) => {
        // if (locations.length && locations.length > 1) {
        //     const lastItem: IPageSettings = locations[locations.length - 1];
        //     const secondLastItem: IPageSettings = locations[locations.length - 2];
        //     const popLastItem: boolean = lastItem.id === secondLastItem.id && lastItem.fileTitle === secondLastItem.fileTitle && lastItem.type === ComponentTypes.Saving;

        //     if (popLastItem) {
        //         locations.pop();
        //     }
        // }
        
        // if (locations.length && locations.length > 0) {
        //     const lastItem: IPageSettings = locations[locations.length - 1];
        //     let popLastItem: boolean;
        //     if (locations.length > 1) {
        //         const secondLastItem: IPageSettings = locations[locations.length - 2];
        //         popLastItem = lastItem.id === secondLastItem.id && lastItem.fileTitle === secondLastItem.fileTitle && lastItem.type === ComponentTypes.Saving;   
        //     }
        //     else {
        //         popLastItem = lastItem.type === ComponentTypes.Saving;
        //     }

        //     if (popLastItem) {
        //         locations.pop();
        //     }
        // }

        if (locations.length && locations.length > 0) {
            const lastItem: IPageSettings = locations[locations.length - 1];
            const popLastItem: boolean = lastItem.type === ComponentTypes.Saving;

            if (popLastItem) {
                locations.pop();
            }
        }
    };

    static itemExists = (existingItem: IStoreItem, newItems: IStoreItem[]): boolean => {
        if (!newItems) return false;
        return existingItem.fileType === FileTypeEnum.file
            ? newItems.some(newItem => newItem.itemId === existingItem.itemId)
            : StoreItemHelper.folderExists(existingItem, newItems);
    };

    static folderExists = (existingItem: IStoreItem, newItems: IStoreItem[]): boolean => {
        const isRoot = !existingItem?.itemId;
        const result = isRoot 
            ? newItems.some(newItem => newItem.driveId === existingItem.driveId && newItem.name === existingItem.name)
            : newItems.some(newItem => newItem.driveId === existingItem.driveId && newItem.itemId === existingItem.itemId);

        return result;
    };

    static getExistingItem = (existingItems: IStoreItem[], newItem: IStoreItem): IStoreItem => {
        if (!existingItems) return null;
        return newItem.fileType === FileTypeEnum.file ? existingItems.find(item => item.itemId === newItem.itemId) : StoreItemHelper.getExistingFolder(existingItems, newItem);
    };

    private static getExistingFolder = (existingItems: IStoreItem[], newItem: IStoreItem): IStoreItem => {
        const isRoot = !newItem?.itemId;
        const result = isRoot
            ? existingItems.find(item => item.driveId === newItem.driveId && item.name === newItem.name)
            : existingItems.find(item => item.driveId === newItem.driveId && item.itemId === newItem.itemId);

        return result;
    };
}